import ApiInterface from '../apiInterface';

export const postInitiateSddStampNode = data => {
  const URL = '/api/cartitem/initiate/sdd/stampnode';
  return ApiInterface.post(URL, data);
};

export const postUpdateSddStampNode = data => {
  const URL = '/api/cartitem/update/sdd/stampnode';
  return ApiInterface.post(URL, data);
};
